var render = function render(){var _vm=this,_c=_vm._self._c;return _c('headroom',{staticClass:"vue-headroom-wrapper",attrs:{"offset":400,"disabled":true},on:{"unpin":_vm.handleUnpin}},[_vm._t("default"),_vm._v(" "),_vm._t("mega-menu")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }